// src/services/referralService.js
// FIXED: Removed broken [api.post](http://api.post) and [res.data](http://res.data) markdown link syntax
// FIXED: /referrals is now in api.js isBackgroundFetch list so 401 never logs user out

import api from './api';

export const referralService = {
  getMyReferral: async () => {
    const res = await api.get('/referrals/my_referral');
    return res.data;
  },

  validateCode: async (code) => {
    const res = await api.get('/referrals/validate_code', { params: { code } });
    return res.data;
  },

  getWallet: async () => {
    const res = await api.get('/referrals/wallet');
    return res.data;
  },

  applyCode: async (code) => {
    const res = await api.post('/referrals/apply_code', { code });
    return res.data;
  },
};

export default referralService;